import { call, put, takeLatest } from "redux-saga/effects";
import { getPermissionCategories } from "components/team/Roles/helpers/customRolesApi";
import type { PermissionCategory } from "components/team/Roles/helpers/customRolesApi";
import {
  PERMISSION_CATEGORIES_GET_REQUEST,
  requestSuccess,
  requestFailure,
} from "./permissionCategoriesGetActions";

function* fetchPermissionCategories() {
  try {
    const data: PermissionCategory[] = yield call(getPermissionCategories);
    yield put(requestSuccess(data));
  } catch (error) {
    yield put(requestFailure(error as Error));
  }
}

export default function* permissionCategoriesGetSaga() {
  // `takeLatest` cancels stale in-flight requests when a new REQUEST comes in
  // (e.g. tenant switch fires reset → next consumer fires a fresh request).
  yield takeLatest(
    PERMISSION_CATEGORIES_GET_REQUEST,
    fetchPermissionCategories
  );
}
